import { Injectable } from '@angular/core';

@Injectable()
export class DataService {
	id: number;
	tipo:string;
	tipoModal:string;
	dialogRef:any;
	dialogModal:any;
	guardado:boolean;
	guardadoModal:boolean;
	modal:string;
	mensaje:string;
	acceso:any;
	idPersonal: any;
	idCliente: any;
	isUpdate: boolean;
	mensajeAlert:string;
	factura:any;
	palabraFiltro: string;
	palabraFiltro2: string;
	ventaEditable: boolean;
}


// WEBPACK FOOTER //
// ./src/app/utils/data.service.ts